// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__28xII","emails":"CreateEditClinics_emails__de9OQ","emailTagLabel":"CreateEditClinics_emailTagLabel__lfLFW"};